import type { AuthUser, ProductAccess } from './types';
export interface AuthUsage { analysesThisMonth:number; limit:number|null; batchLimit:number; }
let user=$state<AuthUser|null>(null);
let usage=$state<AuthUsage|null>(null);
let access=$state<ProductAccess>({allowed:false,reason:'libedge_required'});
let loading=$state(true);
let timer:ReturnType<typeof setInterval>|null=null;
export function authState(){return {
 get user(){return user;}, get usage(){return usage;}, get access(){return access;},
 get loading(){return loading;}, get isLoggedIn(){return user!==null;}, get isPro(){return user?.plan==='pro';}
};}
export async function fetchUser():Promise<AuthUser|null>{
 try{
  const res=await fetch('/api/auth/me',{credentials:'include',cache:'no-store'});
  if(res.ok){
   const data=await res.json() as {user:AuthUser;usage:AuthUsage;access:ProductAccess};
   user=data.user;usage=data.usage;access=data.access??{allowed:false,reason:'unavailable'};
   startSilentRefresh();
  }else{user=null;usage=null;access={allowed:false,reason:'libedge_required'};}
 }catch{access={allowed:false,reason:'unavailable'};}finally{loading=false;}
 return user;
}
export async function ensureProductAccess(options:{redirect?:boolean}={}):Promise<boolean>{
 try{
  const res=await fetch('/api/auth/access',{credentials:'include',cache:'no-store'});
  if(res.status===401){
   access={allowed:false,reason:'reauthenticate'};
   if(options.redirect!==false&&typeof window!=='undefined')window.location.href='/auth/login';
   return false;
  }
  access=res.ok?await res.json() as ProductAccess:{allowed:false,reason:'unavailable'};
 }catch{access={allowed:false,reason:'unavailable'};}
 if(!access.allowed&&options.redirect!==false&&typeof window!=='undefined')window.location.href='/auth/access?reason='+(access.reason??'not_assigned');
 return access.allowed;
}
export async function logout():Promise<void>{
 try{await fetch('/api/auth/logout',{method:'POST',credentials:'include'});}
 finally{
  user=null;usage=null;access={allowed:false,reason:'libedge_required'};stopSilentRefresh();
  if(typeof window!=='undefined')window.location.href='/';
 }
}
export function startSilentRefresh():void{
 if(typeof window==='undefined'||timer)return;
 timer=setInterval(async()=>{
  try{
   const res=await fetch('/api/auth/refresh',{method:'POST',credentials:'include'});
   if(!res.ok){user=null;usage=null;access={allowed:false,reason:'reauthenticate'};}
  }catch{/* A network failure does not send any manuscript content. */}
 },12*60*1000);
}
export function stopSilentRefresh():void{if(timer)clearInterval(timer);timer=null;}
export async function initAuth():Promise<void>{await fetchUser();}
export function refreshUsage(used:number):void{if(usage)usage={...usage,analysesThisMonth:used};}
export function canAnalyzeNow():boolean{
 if(!user||!access.allowed)return true; // Public visitors can run a count-only preview.
 if(user.plan==='pro'||user.institutionId)return true;
 return (usage?.analysesThisMonth??0)<(usage?.limit??5);
}
